export interface MultipartPart {
    label: string;
    blob: Blob;
}

const encoder = new TextEncoder();
const decoder = new TextDecoder();
const HEADER_END = encoder.encode('\r\n\r\n');
const LINE_BREAK_LENGTH = 2;
const DASH_CODE = 45;
const BOUNDARY_PATTERN = /boundary=([^;]+)/;
const NAME_PATTERN = /name="([^"]*)"/;
const IMAGE_TYPE = 'image/webp';

const findBytes = (buffer: Uint8Array, pattern: Uint8Array, from: number): number => {
    for (let i = buffer.indexOf(pattern[0], from); i >= 0 && i <= buffer.length - pattern.length;
        i = buffer.indexOf(pattern[0], i + 1)) {
        let k = 1;
        while (k < pattern.length && buffer[i + k] === pattern[k]) {
            k += 1;
        }
        if (k === pattern.length) {
            return i;
        }
    }
    return -1;
};

export const parseMultipart = async (response: Response): Promise<MultipartPart[]> => {
    const boundaryValue = BOUNDARY_PATTERN.exec(response.headers.get('content-type') ?? '')?.[1];
    if (!boundaryValue) {
        throw new Error('multipart boundary missing');
    }
    const boundary = encoder.encode(`--${boundaryValue.replace(/^"|"$/g, '')}`);
    const buffer = new Uint8Array(await response.arrayBuffer());
    const parts: MultipartPart[] = [];
    let position = findBytes(buffer, boundary, 0);
    while (position >= 0 && buffer[position + boundary.length] !== DASH_CODE) {
        const headStart = position + boundary.length + LINE_BREAK_LENGTH;
        const headEnd = findBytes(buffer, HEADER_END, headStart);
        const next = headEnd < 0 ? -1 : findBytes(buffer, boundary, headEnd + HEADER_END.length);
        if (next < 0) {
            throw new Error('multipart body truncated');
        }
        const label = NAME_PATTERN.exec(decoder.decode(buffer.subarray(headStart, headEnd)))?.[1];
        if (label !== undefined) {
            const body = buffer.subarray(headEnd + HEADER_END.length, next - LINE_BREAK_LENGTH);
            parts.push({ label, blob: new Blob([body], { type: IMAGE_TYPE }) });
        }
        position = next;
    }
    return parts;
};

export const parseTileLabel = (label: string): { x: number; y: number } => {
    const [x, y] = label.split('-').map(Number);
    return { x, y };
};
